module.exports = __webpack_public_path__ + "img/articulated_grabber_instructions_button.d2e11cb9.png";